export default {
  data: [
    {},
    {
      id: 1460,
      title: '1 болт',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1459,
      title: '2 болт',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1491,
      title: 'ВРП',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1535,
      title: 'Вода',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1493,
      title: 'До вы/я',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1534,
      title: 'Под ДТ',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1492,
      title: 'Текущий',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1469,
      title: 'без ушка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1487,
      title: 'брак крышка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1468,
      title: 'брак.барашка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1476,
      title: 'брак.клапан',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1467,
      title: 'винт',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1479,
      title: 'вн.лестница',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1461,
      title: 'вн.резина',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1490,
      title: 'грязь',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1472,
      title: 'контр.гайка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1473,
      title: 'лед',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1471,
      title: 'лестница',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1480,
      title: 'наруж.лестница',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1478,
      title: 'не ясный номер',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1477,
      title: 'не ясный тип',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1465,
      title: 'остаток',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1485,
      title: 'отделенка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1489,
      title: 'палец',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1475,
      title: 'площадка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1484,
      title: 'под АВТО',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1483,
      title: 'под ТС',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1463,
      title: 'под авто/экс',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1531,
      title: 'под бензол',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1464,
      title: 'под вг/тм экс',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1532,
      title: 'под параксилол',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1530,
      title: 'под светлый',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1462,
      title: 'пост.предмет',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1488,
      title: 'ригельный болт',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1470,
      title: 'сварка',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1466,
      title: 'скоба',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1481,
      title: 'сливной прибор',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1482,
      title: 'сливной прибор польный',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1529,
      title: 'течь',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1528,
      title: 'трещина котла',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1474,
      title: 'ш.д',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    },
    {
      id: 1486,
      title: 'шарнир',
      band: {
        version: 1,
        createdBy: 'demo',
        createdAt: '2023-09-15T11:24:16.571+05:00',
        lastModifiedBy: 'demo',
        lastModifiedDate: '2023-09-15T11:24:30.939+05:00',
        deletedAt: null,
        id: 47,
        title: 'Причины отцепки',
        isDeletable: false,
        key: null
      },
      key: null,
      inWords: null,
      binForContractor: null,
      email: '',
      receiveMailing: false,
      childBandNeispravnosti: null,
      productParentType: null
    }
  ]
}
